// Dynamic font scaling for RewardCenter card titles (web): shrink as length grows so
// long names fit inside the card without truncating. Shared between offers and categories.
export var getCardTitleFontSize = function getCardTitleFontSize(titleLength, base) {
  if (titleLength <= 12) return "".concat(base, "rem");
  if (titleLength <= 18) return "".concat(base * 0.9, "rem");
  if (titleLength <= 26) return "".concat(base * 0.8, "rem");
  if (titleLength <= 34) return "".concat(base * 0.72, "rem");
  return "".concat(base * 0.65, "rem");
};